import type { FieldType, ICollection, IScr, IScrLine } from '@/interfaces'
import { Collection, ScrLine } from '@/models/'

export class Scr implements IScr {
	[key: string]: FieldType
	id: number
	subjobId: number
	quoteId: number
	isPartial: boolean
	dueDate: Date | string
	payExpectDate: Date | string
	quoteRevAtSCR: number
	quoteStateAtSCR: string
	scrAmountAtSCR: number
	quoteSignedAtSCR: boolean
	paidAtSCR: boolean
	arLowRiskAtSCR: boolean
	arAmountAtSCR: number
	arAmount90AtSCR: number
	contractAmountAtSCR: number
	contractLowRiskAtSCR: boolean
	createDatetime: Date
	createBy: number
	notes: string
	scrLines: ICollection<IScrLine>
	scrLinesList: string[]
	clientId: string
	clientName: string
	shipDate: Date | string
	showName: string
	invoiceDate: string | Date
	invoiceAmount: number
	approvalDate: Date
	requestDate: Date
	rejectDate: Date
	rejectReason: string
	approveByOps: number
	approveByFin: number
	rejectByOps: number
	rejectByFin: number
	subjobNumber?: string
	subjobName?: string
	productionKickoffDate?: Date | string
	showDate?: Date | string
	scrReviewLines?: IScrLine[]
	arAmount90Days?: number
	arAmount0Days?: number
	arAmount60Days?: number
	arAmount30Days?: number
	salesTeamName?: string

	constructor({
		id,
		subjobId,
		quoteId,
		isPartial,
		dueDate,
		payExpectDate,
		quoteRevAtSCR,
		quoteStateAtSCR,
		scrAmountAtSCR,
		quoteSignedAtSCR,
		paidAtSCR,
		arLowRiskAtSCR,
		arAmountAtSCR,
		arAmount90AtSCR,
		contractAmountAtSCR,
		contractLowRiskAtSCR,
		createDatetime,
		createBy,
		notes,
		scrLines,
		clientId,
		clientName,
		shipDate,
		showName,
		invoiceDate,
		invoiceAmount,
		approvalDate,
		requestDate,
		rejectDate,
		rejectReason,
		approveByOps,
		rejectByOps,
		approveByFin,
		rejectByFin,
		subjobNumber,
		subjobName,
		productionKickoffDate,
		showDate,
		scrReviewLines,
		arAmount90Days,
		arAmount0Days,
		arAmount60Days,
		arAmount30Days,
		salesTeamName
	}: IScr) {
		this.id = id
		this.subjobId = subjobId
		this.quoteId = quoteId
		this.isPartial = isPartial
		this.dueDate = dueDate || ''
		this.payExpectDate = payExpectDate || ''
		this.quoteRevAtSCR = quoteRevAtSCR || 0
		this.quoteStateAtSCR = quoteStateAtSCR || ''
		this.scrAmountAtSCR = scrAmountAtSCR || 0
		this.quoteSignedAtSCR = quoteSignedAtSCR || false
		this.paidAtSCR = paidAtSCR || false
		this.arLowRiskAtSCR = arLowRiskAtSCR
		this.arAmountAtSCR = arAmountAtSCR || 0
		this.arAmount90AtSCR = arAmount90AtSCR || 0
		this.contractAmountAtSCR = contractAmountAtSCR || 0
		this.contractLowRiskAtSCR = contractLowRiskAtSCR
		this.createDatetime = createDatetime || new Date()
		this.createBy = createBy
		this.notes = notes || ''
		this.scrLinesList = []
		this.scrLines = new Collection(ScrLine, scrLines)
		this.clientId = clientId || ''
		this.clientName = clientName || ''
		this.shipDate = shipDate || ''
		this.showName = showName || ''
		this.invoiceDate = invoiceDate || ''
		this.invoiceAmount = invoiceAmount
		this.approvalDate = approvalDate
		this.requestDate = requestDate
		this.rejectDate = rejectDate
		this.rejectReason = rejectReason
		this.approveByOps = approveByOps
		this.rejectByOps = rejectByOps
		this.approveByFin = approveByFin
		this.rejectByFin = rejectByFin
		this.subjobNumber = subjobNumber
		this.subjobName = subjobName
		this.productionKickoffDate = productionKickoffDate
		this.showDate = showDate
		this.scrReviewLines = scrReviewLines
		this.arAmount90Days = arAmount90Days
		this.arAmount0Days = arAmount0Days
		this.arAmount60Days = arAmount60Days
		this.arAmount30Days = arAmount30Days
		this.salesTeamName = salesTeamName
	}
}
